import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${COLORS.BRIGHT_GRAY};
`;

export const StyledText = styled.span`
  ${pickThemeFontStyles('14', '18', 'NORMAL')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledNumber = styled.span`
  ${pickThemeFontStyles('18', '20', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;
